/**
 * Copyright 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Permission } from '../components/Permission';

import { fetchPermissions, removePermission } from '../actions';
import { getPermissions } from '../../../graphql/getPermissions';
import { deletePermission } from '../../../graphql/deletePermission';
import { createFilter } from '../../../utils/filterUtils';
import { NotificationManager } from 'react-notifications';
import { browserHistory } from 'react-router';
import { createFilter as createSearchFilter } from 'react-search-input';
import { Link } from 'react-router';
import { DataTable, SearchForm } from '../../../commonComponents';
import { pageSize } from '../../../utils';
import { ROUTES } from '../../../constants/routes';
import { APIContext } from '../../../commonComponents/auth/APIContext';

const KEYS_TO_FILTERS = ['roles', 'id', 'subject'];

class PermissionsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groups: this.props.defaultValue || [],
      searchTerm: '',
      viewCount: 0,
    };
    this.searchUpdated = this.searchUpdated.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }
  static contextType = APIContext;

  componentDidMount() {
    this.refresh();
  }

  componentWillReceiveProps(props) {
    if (props.location && props.location.query.refresh) {
      this.refresh();
      browserHistory.push(ROUTES.permissions.assignments);
    }
  }

  refresh = (paginationToken, allPages) => {
    const { requester } = this.context;

    fetchPermissions({
      dispatch: this.props.dispatch,
      myInit: {
        limit: pageSize,
        continuation_token: paginationToken,
      },
      requester,
      operation: getPermissions,
      allPages,
    });
  };

  searchUpdated(term) {
    this.setState({ searchTerm: term });
  }

  removeItem(itemId) {
    const { requester } = this.context;
    const { dispatch } = this.props;
    const myInit = {
      customer_id: localStorage.getItem('currentCustomer'),
      id: itemId,
    };

    const callback = () => {
      NotificationManager.success('Permission removed');
      browserHistory.push(`${ROUTES.permissions.assignments}?refresh=true`);
    };

    removePermission({ dispatch, myInit, operation: deletePermission, requester, callback });
  }

  updateViewCount = viewCount => this.state.viewCount !== viewCount && this.setState({ viewCount });

  render() {
    const { error, permissions, paginationToken, isFetching } = this.props;
    const filteredPermissions = permissions
      .filter(createFilter(this.state.filters))
      .filter(createSearchFilter(this.state.searchTerm, KEYS_TO_FILTERS));

    return (
      <div>
        <div className="main wide">
          <div className="container">
            <div className="box">
              <nav className="level">
                <div className="level-left">
                  <div className="level-item">
                    <Link to={ROUTES.permissions.assignmentsNew}>
                      <button className="button is-small is-action  has-besel" type="button">
                        <span>
                          <i className="material-icons ">add</i>
                        </span>
                        New assignment
                      </button>
                    </Link>
                  </div>
                  <div className="level-item">
                    <Link to={ROUTES.permissions.roles}>
                      <button className="button is-small has-besel" type="button">
                        Roles
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="level-right">
                  <SearchForm searchUpdated={this.searchUpdated} />
                </div>
              </nav>
              {permissions.length > 0 && (
                <nav className="level">
                  <div className="level-left" />
                  <div className="level-right">
                    {`Viewing ${this.state.viewCount}/${permissions.length}`}
                    {paginationToken && '+'}
                  </div>
                </nav>
              )}
            </div>

            {error && (
              <div className="message is-danger">
                <div className="message-body">
                  {typeof error === 'string' && <div key="0">{error}</div>}
                  {typeof error !== 'string' &&
                    Object.keys(error).map((el, index) => (
                      <div key={index}>
                        {el.replace(/_/g, ' ').toUpperCase()}:{' '}
                        {typeof error[el] === 'string'
                          ? error[el]
                          : Object.keys(error[el][0]).map(element => error[el][0][element])}
                      </div>
                    ))}
                </div>
              </div>
            )}

            <DataTable
              data={filteredPermissions}
              pagination={{
                show: !!paginationToken,
                loadNextPage: () => this.refresh(paginationToken),
                loadAllPages: () => this.refresh(paginationToken, true),
              }}
              isLoading={isFetching}
              headers={[
                { label: 'Subject', field: 'subject' },
                { label: 'Id', field: 'id' },
                { label: 'Roles', field: 'roles' },
                { label: 'Created At', field: 'created_at' },
                { label: 'Updated At', field: 'updated_at' },
                { label: '' },
              ]}
              row={Permission}
              rowActions={{ removeItem: this.removeItem }}
              updateViewCount={this.updateViewCount}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    permissions = {
      items: [],
      paginationToken: null,
      isFetching: false,
      error: null,
      removed: false,
    },
  } = state;

  return {
    error: permissions.error,
    isFetching: permissions.isFetching,
    permissions: permissions.items,
    paginationToken: permissions.paginationToken,
    removed: permissions.removed,
  };
};

export default connect(mapStateToProps)(PermissionsPage);
